import {FC, useState, createContext, useContext, ReactNode} from 'react'

type DropdownOpenContextProps = {
  dropdownOpenTaskId: number | null
  setDropdownOpenTaskId: (id: number | null) => void
}

const DropdownOpenContext = createContext<DropdownOpenContextProps>({
  dropdownOpenTaskId: null,
  setDropdownOpenTaskId: () => {},
})

const DropdownOpenProvider: FC<{children?: ReactNode}> = ({children}) => {
  const [dropdownOpenTaskId, setDropdownOpenTaskId] = useState<number | null>(null)

  return (
    <DropdownOpenContext.Provider value={{dropdownOpenTaskId, setDropdownOpenTaskId}}>
      {children}
    </DropdownOpenContext.Provider>
  )
}

const useDropdownOpen = () => useContext(DropdownOpenContext)

export {DropdownOpenProvider, useDropdownOpen}
